import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'healthhazard',
  templateUrl: './healthhazard.component.html',
  styleUrls: ['./healthhazard.component.css']
})
export class HealthhazardComponent implements OnInit {

  constructor() { }

  checkAllHealthHazard = false;

  acuteToxicity: any;
  acuteToxicityChecked = false;

  acuteToxicityRoute: any;
  acuteToxicityRouteChecked = false;

  skinCorrosionIrritationRoute: any;
  skinCorrosionIrritationRouteChecked = false;

  aspirationHazard: any;
  aspirationHazardChecked = false;

  bioHazardInfectiousMat: any;
  bioHazardInfectiousMatChecked = false;

  carcinogenicity: any;
  carcinogenicityChecked = false;

  germCellMutagenicity: any;
  germCellMutagenicityChecked = false;

  reproductiveToxicity: any;
  reproductiveToxicityChecked = false;

  respiratorySkinSen: any;
  respiratorySkinSenChecked = false;

  seriousEyeDamage: any;
  seriousEyeDamageChecked = false;

  skinCorrosionIrritation: any;
  skinCorrosionIrritationChecked = false;

  specificTargetOriginTox: any;
  specificTargetOriginToxChecked = false;

  specificTargetOrgExposure: any;
  specificTargetOrgExposureChecked = false;

  healthHazardsnotClass: any;
  healthHazardsnotClassChecked = false;

  ngOnInit() {
  }

  onAcuteToxicityChecked() {
    this.acuteToxicity = '';
    if (this.acuteToxicityChecked) {
      this.acuteToxicity = 'AcuteToxicity';
    }
  }

  onAcuteToxicityRouteChecked() {
    this.acuteToxicityRoute = '';
    if (this.acuteToxicityRouteChecked) {
      this.acuteToxicityRoute = 'AcuteToxicityPropRouteEntry';
    }
  }

  onSkinCorrosionIrritationRouteChecked() {
    this.skinCorrosionIrritationRoute = '';
    if (this.skinCorrosionIrritationRouteChecked) {
      this.skinCorrosionIrritationRoute = 'SkinCorrosionPropRouteEntry';
    }
  }

  onAspirationHazardChecked() {
    this.aspirationHazard = '';
    if (this.aspirationHazardChecked) {
      this.aspirationHazard = 'AspirationHazard';
    }
  }

  onBiohazardousInfectiousMatChecked() {
    this.bioHazardInfectiousMat = '';
    if (this.bioHazardInfectiousMatChecked) {
      this.bioHazardInfectiousMat = 'BiohazardousInfectiousMaterials';
    }
  }

  onCarcinogenicityChecked() {
    this.carcinogenicity = '';
    if (this.carcinogenicityChecked) {
      this.carcinogenicity = 'Carcinogenicity';
    }
  }

  onGermCellMutagenicityChecked() {
    this.germCellMutagenicity = '';
    if (this.germCellMutagenicityChecked) {
      this.germCellMutagenicity = 'GermCellMutagenicity';
    }
  }

  onReproductiveToxicityChecked() {
    this.reproductiveToxicity = '';
    if (this.reproductiveToxicityChecked) {
      this.reproductiveToxicity = 'ReproductiveToxicity';
    }
  }

  onRespiratorySkinSenChecked() {
    this.respiratorySkinSen = '';
    if (this.respiratorySkinSenChecked) {
      this.respiratorySkinSen = 'RespiratoryOrSkinSensitization';
    }
  }

  onSeriousEyeDamageIrrChecked() {
    this.seriousEyeDamage = '';
    if (this.seriousEyeDamageChecked) {
      this.seriousEyeDamage = 'SeriousEyeDamageEyeIrritation';
    }
  }

  onSkinCorrosionIrrChecked() {
    this.skinCorrosionIrritation = '';
    if (this.skinCorrosionIrritationChecked) {
      this.skinCorrosionIrritation = 'SkinCorrosionIrritation';
    }
  }

  onSpecificTargetOriginToxSingleExpoChecked() {
    this.specificTargetOriginTox = '';
    if (this.specificTargetOriginToxChecked) {
      this.specificTargetOriginTox = 'SpecificTargetOrganToxicitySingleExposure';
    }
  }

  onSpecificTargetOriginToxRepeatedExpoChecked() {
    this.specificTargetOrgExposure = '';
    if (this.specificTargetOrgExposureChecked) {
      this.specificTargetOrgExposure = 'SpecificTargetOrganToxicityRepeatedExposure';
    }
  }

  onHealthHazardsnotClassChecked() {
    this.healthHazardsnotClass = '';
    if (this.healthHazardsnotClassChecked) {
      this.healthHazardsnotClass = 'HealthHazardsNotOtherwiseClassified';
    }
  }

  onSelectedHealthHazardClicked(event) {
    if (event.checked) {
      this.acuteToxicityChecked = true;
      if (this.acuteToxicityChecked) {
        this.onAcuteToxicityChecked();
      }
      this.acuteToxicityRouteChecked = true;
      if (this.acuteToxicityRouteChecked) {
        this.onAcuteToxicityRouteChecked();
      }
      this.skinCorrosionIrritationRouteChecked = true;
      if (this.skinCorrosionIrritationRouteChecked) {
        this.onSkinCorrosionIrritationRouteChecked();
      }
      this.aspirationHazardChecked = true;
      if (this.aspirationHazardChecked) {
        this.onAspirationHazardChecked();
      }
      this.bioHazardInfectiousMatChecked = true;
      if (this.bioHazardInfectiousMatChecked) {
        this.onBiohazardousInfectiousMatChecked();
      }
      this.carcinogenicityChecked = true;
      if (this.carcinogenicityChecked) {
        this.onCarcinogenicityChecked();
      }
      this.germCellMutagenicityChecked = true;
      if (this.germCellMutagenicityChecked) {
        this.onGermCellMutagenicityChecked();
      }
      this.reproductiveToxicityChecked = true;
      if (this.reproductiveToxicityChecked) {
        this.onReproductiveToxicityChecked();
      }
      this.respiratorySkinSenChecked = true;
      if (this.respiratorySkinSenChecked) {
        this.onRespiratorySkinSenChecked();
      }
      this.seriousEyeDamageChecked = true;
      if (this.seriousEyeDamageChecked) {
        this.onSeriousEyeDamageIrrChecked();
      }
      this.skinCorrosionIrritationChecked = true;
      if (this.skinCorrosionIrritationChecked) {
        this.onSkinCorrosionIrrChecked();
      }
      this.specificTargetOriginToxChecked = true;
      if (this.specificTargetOriginToxChecked) {
        this.onSpecificTargetOriginToxSingleExpoChecked();
      }
      this.specificTargetOrgExposureChecked = true;
      if (this.specificTargetOrgExposureChecked) {
        this.onSpecificTargetOriginToxRepeatedExpoChecked();
      }
      this.healthHazardsnotClassChecked = true;
      if (this.healthHazardsnotClassChecked) {
        this.onHealthHazardsnotClassChecked();
      }

    } else {
      this.acuteToxicityChecked = false;
      this.acuteToxicity = '';

      this.acuteToxicityRouteChecked = false;
      this.acuteToxicityRoute = '';

      this.skinCorrosionIrritationRouteChecked = false;
      this.skinCorrosionIrritationRoute = '';

      this.aspirationHazardChecked = false;
      this.aspirationHazard = '';

      this.bioHazardInfectiousMatChecked = false;
      this.bioHazardInfectiousMat = '';

      this.carcinogenicityChecked = false;
      this.carcinogenicity = '';

      this.germCellMutagenicityChecked = false;
      this.germCellMutagenicity = '';

      this.reproductiveToxicityChecked = false;
      this.reproductiveToxicity = '';

      this.respiratorySkinSenChecked = false;
      this.respiratorySkinSen = '';

      this.seriousEyeDamageChecked = false;
      this.seriousEyeDamage = '';

      this.skinCorrosionIrritationChecked = false;
      this.skinCorrosionIrritation = '';

      this.specificTargetOriginToxChecked = false;
      this.specificTargetOriginTox = '';

      this.specificTargetOrgExposureChecked = false;
      this.specificTargetOrgExposure = '';

      this.healthHazardsnotClassChecked = false;
      this.healthHazardsnotClass = '';
    }
  }

  getCheckedValues() {
    const result = [];
    if (this.acuteToxicityChecked) { result.push(this.acuteToxicity); }
    if (this.acuteToxicityRouteChecked) { result.push(this.acuteToxicityRoute); }
    if (this.skinCorrosionIrritationRouteChecked) { result.push(this.skinCorrosionIrritationRoute); }
    if (this.aspirationHazardChecked) { result.push(this.aspirationHazard); }
    if (this.bioHazardInfectiousMatChecked) { result.push(this.bioHazardInfectiousMat); }
    if (this.carcinogenicityChecked) { result.push(this.carcinogenicity); }
    if (this.germCellMutagenicityChecked) { result.push(this.germCellMutagenicity); }
    if (this.reproductiveToxicityChecked) { result.push(this.reproductiveToxicity); }
    if (this.respiratorySkinSenChecked) { result.push(this.respiratorySkinSen); }
    if (this.seriousEyeDamageChecked) { result.push(this.seriousEyeDamage); }
    if (this.skinCorrosionIrritationChecked) { result.push(this.skinCorrosionIrritation); }
    if (this.specificTargetOriginToxChecked) { result.push(this.specificTargetOriginTox); }
    if (this.specificTargetOrgExposureChecked) { result.push(this.specificTargetOrgExposure); }
    if (this.healthHazardsnotClassChecked) { result.push(this.healthHazardsnotClass); }

    return result;
  }

}
